import React, { useState } from 'react';
import { USP_COLORS } from './DemoUSPBadges';

const DemoUSPCoverage = ({ usps = [], scenarios = [] }) => {
  const [expanded, setExpanded] = useState(false);

  if (!usps.length) return null;

  return (
    <div className="demo-usp-coverage" style={{
      marginBottom: 20,
      border: '1px solid #ddd',
      borderRadius: 4,
      backgroundColor: 'white',
      overflow: 'hidden',
    }}>
      <div
        onClick={() => setExpanded(!expanded)}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '10px 16px',
          cursor: 'pointer',
          backgroundColor: '#fafafa',
          borderBottom: expanded ? '1px solid #ddd' : 'none',
        }}
      >
        <span style={{ fontSize: 13, fontWeight: 600, color: '#333' }}>
          Platform USP Coverage — {usps.length} USPs across {scenarios.length} Scenarios
        </span>
        <span style={{ fontSize: 12, color: '#666' }}>{expanded ? '▼' : '▶'}</span>
      </div>
      {expanded && (
        <div style={{ padding: 16, overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', padding: '6px 8px', borderBottom: '2px solid #1976d2', fontWeight: 600 }}>
                  USP
                </th>
                {scenarios.map(s => (
                  <th key={s.id} style={{
                    textAlign: 'center', padding: '6px 4px', borderBottom: '2px solid #1976d2',
                    fontWeight: 500, fontSize: 10, maxWidth: 80, whiteSpace: 'nowrap',
                  }}>
                    S{s.order}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {usps.map(usp => (
                <tr key={usp.id}>
                  <td style={{
                    padding: '5px 8px', borderBottom: '1px solid #eee', fontWeight: 500,
                    color: USP_COLORS[usp.id] || '#333',
                  }}>
                    {usp.shortName || usp.name}
                  </td>
                  {scenarios.map(s => {
                    const has = (s.uspTags || []).includes(usp.id);
                    return (
                      <td key={s.id} style={{
                        textAlign: 'center', padding: '5px 4px', borderBottom: '1px solid #eee',
                      }}>
                        {has && (
                          <span style={{
                            display: 'inline-block', width: 14, height: 14, borderRadius: '50%',
                            backgroundColor: USP_COLORS[usp.id] || '#1976d2',
                          }} />
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DemoUSPCoverage;
